<template>

  <el-card
    v-if="card && card.id && this.card.status !== this.$constants.card.statuses.STATUS_COMPLETED"
    class="card-agree-buttons"
    style="margin-top: 20px"
  >
    <div style="display: flex; justify-content: space-between;">
      <div class="card-agree-buttons-text" style="font-size: 24px">Решение</div>
      <div>
        <el-button
          v-if="$can(card, 'card.disagree') && $rulesPass(card, 'card.disagree')"
          type="danger"
          icon="fas fa-undo"
          :loading="loading"
          @click="disagreeNegotiation"
        >
          Отправить на доработку
        </el-button>


        <el-button
          v-if="$can(card, 'card.agree')"
          :disabled="!$rulesPass(card, 'card.agree')"
          type="success"
          icon="fas fa-check"
          :loading="loading"
          @click="agreeNegotiation"
        >
          <span v-if="currentNegotiation && currentNegotiation.type === 'self'">Отправить на согласование</span>
          <span v-else>Согласовать</span>
        </el-button>
      </div>
    </div>

  </el-card>

</template>

<script>


import {mapGetters} from "vuex";
import CommentsBlock from "@/components/comments/CommentsBlock.vue";

export default {
  name: "agree-buttons",
  components: { CommentsBlock },

  props: {},

  computed: {
    ...mapGetters('card', {
      card: 'card',
    }),
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
      currentNegotiation: 'currentNegotiation',
    }),
    ...mapGetters('card/errors', {
      cardWarnings: 'warnings',
    }),
  },
  data() {
    return {
      loading: false,
    }
  },
  mounted() {},
  methods: {
    agreeNegotiation(){
      if( this.cardWarnings.length ){
        let message = 'В карте присутствуют следующие предупреждения:<br><br>';
        this.cardWarnings.forEach(warning => {
          message += warning.errorText + '<br>';
        })
        message += '<br>Вы уверены, что хотите продолжить?';
        this.$confirm(message, 'Внимание', {
          confirmButtonText: 'Да',
          cancelButtonText: 'нет',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.sendAgreeNegotiation();
        })
      } else {
        this.sendAgreeNegotiation();
      }
    },

    sendAgreeNegotiation(){
      this.loading = true;
      this.$api.card.agreeCard({
        card_id: this.card.id
      })
        .then((data) => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Этап успешно сохранен'
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('card/loadCard');
        })
    },

    disagreeNegotiation(){
      this.loading = true;
      this.$api.card.disagreeCard({
        card_id: this.card.id
      })
        .then((data) => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Этап успешно сохранен'
          });
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('card/loadCard');
        })
    },


  }
}
</script>

<style lang="scss">
</style>